import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyDECW9icms7B71eF8HX-CtbLF6FrWh-ovk",
  authDomain: "web-app-4daa9.firebaseapp.com",
  // ✅ Corrected URL based on your console warning
  databaseURL: "https://web-app-4daa9-default-rtdb.asia-southeast1.firebasedatabase.app", 
  projectId: "web-app-4daa9",
  storageBucket: "web-app-4daa9.firebasestorage.app",
  messagingSenderId: "1094093629917",
  appId: "1:1094093629917:web:90421d27f04442a44c2e34",
  measurementId: "G-1811LYLFT0"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export instances
export const auth = getAuth(app);
export const db = getDatabase(app); 

export default app;